import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgC1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "C1",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "#4ADE80"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 29.999,
				y: 70,
				width: 40,
				height: 20,
				rx: 8.28,
				fill: "#DCFCE7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.3067 19.0333C24.8636 14.1831 28.682 10 33.5524 10H66.445C71.3154 10 75.1338 14.1831 74.6907 19.0333L71.1001 58.3354C70.7106 62.5987 67.1355 65.8621 62.8544 65.8621H37.1429C32.8619 65.8621 29.2868 62.5987 28.8973 58.3354L25.3067 19.0333Z",
				fill: "url(#paint0_linear_7220_21631)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.9971 49.9453C51.5337 53.3145 57.9164 55.1663 61.5541 53.31",
				stroke: "#22C55E",
				strokeWidth: 2.75862,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49 40.4C49 39.0745 50.0745 38 51.4 38C52.7255 38 53.8 39.0745 53.8 40.4V42.86C53.8 44.1855 52.7255 45.26 51.4 45.26C50.0745 45.26 49 44.1855 49 42.86V40.4Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M56.8311 40.4C56.8311 39.0745 57.9056 38 59.2311 38C60.5565 38 61.6311 39.0745 61.6311 40.4V42.86C61.6311 44.1855 60.5565 45.26 59.2311 45.26C57.9056 45.26 56.8311 44.1855 56.8311 42.86V40.4Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.25 35L48.25 33",
				stroke: "#14532D",
				strokeWidth: 2.3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58 35L62 33",
				stroke: "#14532D",
				strokeWidth: 2.3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_7220_21631",
				x1: 49.9987,
				y1: 10,
				x2: 49.9987,
				y2: 65.8621,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F0FDF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DCFCE7"
				})]
			}) })
		]
	})
});
export default SvgC1;
